import React, { useState, useCallback, useRef, useEffect } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Overlay from './Overlay';
import svgFile from './overlay.svg';

import './App.scss';
function generateDownload(canvas, crop) {
  if (!crop || !canvas) {
    return;
  }

  canvas.toBlob(
      (blob) => {
        const previewUrl = window.URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.download = 'cropPreview.png';
        anchor.href = URL.createObjectURL(blob);
        anchor.click();

        window.URL.revokeObjectURL(previewUrl);
      },
      'image/png',
      1
  );
}

export default function App() {
  const [upImg, setUpImg] = useState();
  const [upOverlay, setUpOverlay] = useState();
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: 1 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [color, setColor] = useState('#F4b502');
  const [roundness, setRoundness] = useState(false);
  const defaultColor = '#F4b502';
  const text = '<svg class="img-fluid" id="outputsvg" xmlns="http://www.w3.org/2000/svg" width="2000" height="2000" viewBox="0 0 20000 20000"><g id="ovelayImg" fill="rgb(244,181,8)" style="transform: none;"><g><path id="pWFXNauKO" d="M0 10000 l0 -10000 10000 0 10000 0 0 10000 0 10000 -10000 0 -10000 0 0 -10000z m10510 9089 c1620 -82 3226 -623 4590 -1547 704 -476 1357 -1071 1921 -1748 694 -833 1250 -1829 1603 -2873 266 -785 413 -1541 466 -2401 l11 -175 0 -345 0 -345 -11 -175 c-53 -860 -200 -1616 -466 -2401 -257 -761 -621 -1495 -1067 -2157 l-109 -162 -52 47 -51 48 -8 27 -7 26 -45 40 -45 40 0 14 0 15 -62 61 c-33 34 -65 62 -70 62 l-8 0 0 25 0 24 -23 23 c-13 13 -42 40 -66 60 l-44 37 6 15 6 15 -22 20 c-12 11 -38 34 -57 51 -19 17 -36 35 -36 40 -1 6 -2 14 -3 19 -1 13 -76 87 -107 107 l-25 17 6 16 5 16 -70 68 -71 68 7 10 6 10 -56 54 -56 53 0 16 0 15 -62 61 c-34 33 -66 60 -71 60 l-9 0 5 20 5 20 -69 64 -69 64 0 17 0 17 -46 44 c-25 24 -50 44 -55 44 l-10 0 2 13 c1 6 1 17 0 23 -1 14 -76 90 -109 112 l-23 15 6 14 5 15 -71 68 -71 69 7 10 6 11 -46 45 c-25 25 -50 45 -55 45 l-10 0 -1 13 c-1 6 -2 17 -3 24 -1 15 -42 60 -95 105 l-44 37 6 15 6 14 -60 56 c-33 31 -64 56 -69 56 l-10 0 0 28 0 29 -46 39 c-26 21 -51 41 -55 42 l-9 4 0 24 0 24 -42 41 c-24 22 -53 48 -65 56 l-23 15 0 21 0 20 -52 50 -52 50 -2 14 c-3 18 -25 44 -81 96 l-42 39 -4 22 c-3 11 -5 -413 -5 -943 l-1 -965 52 -48 c29 -26 55 -48 60 -48 l7 0 0 -22 0 -22 68 -65 67 -65 -3 -12 -2 -11 46 -47 c25 -26 56 -54 70 -63 l25 -16 -6 -17 -5 -17 32 -33 c18 -18 43 -39 56 -47 l22 -15 0 -20 0 -21 65 -62 65 -63 0 -17 0 -17 47 -44 c25 -24 49 -44 53 -44 4 0 10 -12 13 -28 l6 -27 36 -38 c20 -21 47 -44 60 -53 l23 -15 5 -28 6 -29 65 -57 65 -57 -6 -14 -5 -13 47 -46 c26 -25 50 -45 55 -45 l8 0 5 -28 6 -28 45 -44 c25 -24 52 -47 60 -52 l16 -9 0 -20 0 -21 69 -65 69 -65 -5 -14 -5 -14 48 -45 c27 -25 52 -45 56 -45 l8 0 0 -22 0 -22 65 -63 65 -62 0 -15 0 -14 26 -31 26 -31 -60 -68 c-33 -37 -95 -101 -136 -142 l-76 -74 0 17 0 17 -62 60 c-35 33 -66 60 -71 60 l-8 0 6 19 5 18 -68 64 -69 64 -6 27 -7 26 -47 42 -48 42 0 13 0 13 -35 39 c-19 21 -50 50 -68 63 l-33 25 5 17 4 18 -36 35 c-21 19 -52 47 -71 64 l-33 30 7 11 7 11 -52 50 c-28 27 -56 49 -62 49 l-9 0 6 19 6 18 -48 48 c-27 26 -58 54 -71 62 l-23 16 6 17 6 17 -56 51 -55 51 0 15 0 16 -67 65 -68 66 0 13 0 14 -35 39 c-19 21 -50 50 -68 63 l-33 25 4 17 5 17 -27 27 c-14 15 -40 38 -58 51 l-32 24 5 14 5 13 -61 61 c-33 33 -65 61 -71 61 l-10 0 6 19 6 18 -53 51 c-30 28 -62 58 -72 65 l-19 14 8 12 7 13 -56 53 -56 54 0 16 0 15 -67 65 -68 66 0 13 0 14 -25 29 c-14 15 -45 45 -69 65 l-44 37 6 15 6 15 -59 52 -58 52 5 12 4 13 -62 61 c-35 33 -67 61 -71 61 l-9 0 2 13 c4 33 4 33 -102 128 l-31 28 7 11 7 12 -58 55 -59 55 2 12 3 12 -43 45 c-24 26 -56 54 -70 64 l-28 18 6 17 6 17 -72 66 -71 66 7 11 7 11 -59 56 -58 56 3 12 2 12 -46 47 c-25 26 -56 54 -70 62 l-24 16 0 24 0 23 -22 22 c-13 11 -37 32 -55 46 l-32 24 5 14 6 14 -62 61 c-35 33 -67 60 -72 60 l-10 0 5 20 5 19 -52 50 c-28 28 -60 57 -70 64 l-19 14 7 12 8 12 -56 53 -56 53 0 16 0 17 -67 66 -68 67 3 12 2 12 -28 29 c-15 16 -47 45 -70 64 l-42 35 5 14 6 14 -58 56 -57 55 -1 17 -1 16 -60 57 c-32 31 -62 56 -66 56 l-8 0 0 19 c0 26 -10 51 -21 51 l-9 0 0 -1325 0 -1326 25 -23 25 -24 -5 -14 -6 -15 55 -51 56 -51 0 -14 0 -15 55 -56 c30 -31 59 -56 65 -56 l10 0 0 -24 0 -24 48 -46 c26 -25 50 -46 55 -46 l7 0 0 -22 0 -22 65 -63 65 -63 0 -14 0 -14 28 -29 c16 -15 46 -43 66 -61 l38 -33 2 -24 3 -23 29 -27 c16 -15 39 -34 52 -42 l22 -15 0 -21 0 -21 65 -63 65 -63 0 -15 0 -16 47 -46 c26 -25 58 -52 70 -60 l24 -16 -6 -17 -5 -17 32 -33 c18 -18 43 -39 56 -47 l22 -15 0 -21 0 -21 65 -62 65 -62 0 -15 0 -15 28 -29 c16 -15 46 -43 66 -61 l38 -33 2 -24 3 -23 29 -27 c16 -15 39 -34 52 -42 l22 -15 0 -20 0 -21 65 -62 65 -63 0 -16 0 -17 47 -46 c26 -25 58 -52 70 -60 l24 -16 -6 -17 -5 -17 55 -50 55 -50 0 -17 0 -17 43 -42 c23 -23 52 -50 65 -59 l24 -16 2 -24 3 -24 52 -50 c29 -27 60 -53 67 -57 l15 -8 -6 -19 -6 -18 14 -13 c8 -8 33 -30 55 -49 l42 -35 0 -19 0 -18 57 -54 c31 -30 60 -54 65 -54 l8 0 0 -25 0 -25 55 -52 c31 -29 63 -56 71 -61 l15 -8 -6 -19 -6 -18 56 -48 55 -48 0 -17 0 -17 31 -31 31 -31 -5 -13 -5 -12 -186 -118 c-1326 -841 -2778 -1309 -4366 -1407 l-175 -11 -345 0 -345 0 -175 11 c-860 53 -1616 200 -2401 466 -2674 905 -4789 3017 -5699 5689 -243 715 -390 1425 -455 2200 l-16 190 -8 272 -7 273 7 272 8 273 16 190 c52 625 156 1198 320 1770 510 1773 1523 3319 2961 4516 1195 995 2686 1683 4226 1949 687 119 1344 156 2078 119z"></path></g></g></svg>';

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setUpImg(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  const loadImage = () => {
    let img = new Image();
    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(text, "text/xml");
    let svg = xmlDoc.getElementsByTagName('svg')[0];
    svg.getElementById('ovelayImg').setAttribute('fill', color);
    img.src = 'data:image/svg+xml;base64,' + window.btoa(svg.outerHTML);
    setUpOverlay(img);
  }

  useEffect(() => {
    loadImage();
  }, [color]);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current || !upOverlay) {
      return;
    }
    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext('2d');
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = 'high';

    if (roundness) {
      ctx.beginPath();
      ctx.arc(crop.width * scaleX / 2 - 0,
        crop.height * scaleY / 2, crop.width * scaleX / 2, crop.width * scaleX / 2, Math.PI * 2, true);
      ctx.closePath();
      ctx.clip();
    }

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY
    );

    ctx.drawImage(upOverlay, 0, 0, crop.width * scaleX,
        crop.height * scaleY,);

    }, [completedCrop, upOverlay, roundness]);

  return (
      <div className="App">
        <div className={"content wrapper"}>
          <div className={'cols'}>
            <div className={'col-6'}>

              <ReactCrop
                src={upImg}
                onImageLoaded={onLoad}
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={(c) => setCompletedCrop(c)}
              />
              <p>
                Загрузи необходимое изображение
              </p>
              <div>
                <input type="file" accept="image/*" onChange={onSelectFile} />
              </div>
            </div>
            <div className={'col-6 ml-20'}>
              <div>
                <canvas
                  ref={previewCanvasRef}
                  // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                  style={{
                    width: Math.round(completedCrop?.width ?? 0),
                    height: Math.round(completedCrop?.height ?? 0)
                  }}
                />

              </div>

              {completedCrop?.width && completedCrop?.height ? (
                  <div className={'terminal'}>
                    <div className={'wrapper'}>
                    <div className={'terminal-color'}>
                      <label>
                      <span>Выбрать цвет:</span>
                        <input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
                      </label>
                      {defaultColor !== color ? (
                        <span onClick={() => setColor(defaultColor)}>Стандартный цвет</span>
                      ) : ''}
                    </div>

                    <div className={'terminal-round'}>
                      <label>
                      <span>Закруглить:</span>
                      <input type="checkbox" value={1} checked={roundness} onChange={(e) => setRoundness(!roundness)} />
                      </label>
                    </div>

                    <div className={'terminal-download'}>
                      <button
                        type="button"
                        disabled={!completedCrop?.width || !completedCrop?.height}
                        onClick={() =>
                          generateDownload(previewCanvasRef.current, completedCrop)
                        }
                      >
                        Скачать изображение
                      </button>
                    </div>
                    </div>
                  </div>
              ) : ''}
            </div>
          </div>
        </div>
      </div>
  );
}
